import {
  REGION_AU,
  SSO_DET_NSW_EMAIL_DOMAIN,
  SSO_DET_NSW_SCHOOL_EMAIL,
} from 'global/constants';

export default function shouldUseSSO(email: string | null | undefined) {
  return (
    email &&
    email.endsWith(SSO_DET_NSW_EMAIL_DOMAIN) &&
    !email.endsWith(SSO_DET_NSW_SCHOOL_EMAIL) &&
    process.env.REACT_APP_REGION === REGION_AU
  );
}
